/**
 * Created by griga on 7/11/16.
 */


import {Routes, RouterModule} from '@angular/router';
import {MainLayoutComponent} from "./shared/layout/app-layouts/main-layout.component";
import {AuthLayoutComponent} from "./shared/layout/app-layouts/auth-layout.component";
import {ModuleWithProviders} from "@angular/core";
import { IsActivatedAccountGuard } from './shared/services/activated-account-guard.service';
import { IsActivateMenuGuard } from './core/guards/is-activate-menu.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'auth',
        pathMatch: 'full'
    },
    {
        path: '',
        component: MainLayoutComponent,
        children: [
            {
                path: '', redirectTo: 'dashboard', pathMatch: 'full'
            },
            // {
            //     path: 'home',
            //     loadChildren: 'app/+home/home.module#HomeModule'
            // },
            {
                path: 'dashboard',
                //canActivate: [IsActivateMenuGuard],
                loadChildren: 'app/+accueil/accueil.module#AccueilModule',
                canDeactivate:[
                    IsActivatedAccountGuard
                ]
            },
            // {
            //     path: 'agence',
            //     loadChildren: 'app/+agence/agence.module#AgenceModule'
            // },
            {
                path: 'admin',
                canActivate: [IsActivateMenuGuard],
                loadChildren: 'app/+admin/admin.module#AdminModule'
            },
            {
                path: 'infos',
                canActivate: [IsActivateMenuGuard],
                loadChildren: 'app/+infos/infos.module#InfosModule'
            },
            {
                path: 'contactez-nous',
                loadChildren: 'app/+contact-us/contact-us.module#ContactUsModule'
            },
            {
                path: 'transaction',
                canActivate: [IsActivateMenuGuard],
                loadChildren: 'app/+transaction/transaction.module#TransactionModule'
            },
            {
                path: 'commande-e-cartes',
                canActivate: [IsActivateMenuGuard],
                loadChildren: 'app/+commande/commande.module#CommandeModule'
            },
            {
                path: 'envoi-e-cartes',
                canActivate: [IsActivateMenuGuard],
                loadChildren: 'app/+send-e-cartes/send-e-cartes.module#SendECartesModule'
            },
            {
                path: 'consultation-compte',
                canActivate: [IsActivateMenuGuard],
                loadChildren: 'app/+consultation-compte/consultation-compte.module#ConsultationCompteModule'
            },
             {
                 path: 'welcome',
                 loadChildren: 'app/+welcome/welcome.module#WelcomeModule'
             },
             {
                 path: 'customer',
                 canActivate: [IsActivateMenuGuard],
                 loadChildren: 'app/+customer/customer.module#CustomerModule'
             }
            //,
            // {
            //     path: 'type-user',
            //     loadChildren: 'app/+type-user/type-user.module#TypeUserModule'
            // },
            // {
            //     path: 'type-transaction',
            //     loadChildren: 'app/+type-transaction/type-transaction.module#TypeTransactionModule'
            // },
            // {
            //     path: 'statut',
            //     loadChildren: 'app/+statut/statut.module#StatutModule'
            // },
            // {
            //     path: 'admin',
            //     loadChildren: 'app/+admin/admin.module#AdminModule'
            // },
            // {
            //     path: 'zone',
            //     loadChildren: 'app/+zone/zone.module#ZoneModule'
            // }
        ]
    },
    {
        path: 'auth',
        component: AuthLayoutComponent,
        loadChildren: 'app/+auth/auth.module#AuthModule'
    },
    
      { path: '**', redirectTo: 'accueil' }

];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {useHash: true});
